export const contactApiHandler = {
  contactOrganization: {
    method: "POST",
    path: (payload: { organizationId: string | number }) => `contact/organization/${payload.organizationId}`
  },
  technicalSupport: {
    method: "POST",
    path: () => `technical-support`
  }
};